module.exports = __webpack_public_path__ + "static/media/service-copy-trading.5a94dcc6.png";